
import { fetchNewsPage } from '@/assets/scripts/api'
import { findNewsBySlug } from '@/assets/scripts/dataObjects/dataPageNews'
import {
  bestPicFormat,
  createNavigationPopinItem,
  IS_BRANCH_STAGING,
} from '@/assets/scripts/utils'
import DetailToPopin from '@/mixins/DetailToPopin'
import PageData from '@/mixins/PageData'
import SeeMore from '@/mixins/SeeMore'

const PAGE_ITEM_COUNT = 12
const envprodNewsFilter = (n) => new Date(n.rawDate).getTime() < new Date().getTime()
const getEnvNews = (news) => !IS_BRANCH_STAGING ? news.filter(envprodNewsFilter) : news

export default {
  popinContentComponent: 'DetailNews',

  mixins: [PageData, SeeMore, DetailToPopin],

  async asyncData({ payload }) {
    const apiData = payload || await fetchNewsPage()
    return { apiData }
  },

  data() {
    return {
      filters: [
        { label: 'Franchisés', enabled: false },
        { label: 'Bières', enabled: false },
        { label: 'Spiritueux', enabled: false },
        { label: 'Temps fort', enabled: false },
        { label: 'Street-food', enabled: false },
        { label: 'Recette', enabled: false },
      ]
    }
  },

  computed: {
    news() {
      if (!this.apiData.news || this.apiData.news.length === 0) { return [] }

      const news = getEnvNews(this.apiData.news)
      const filterCategories = this.filters.map((f, index) => f.enabled ? `${index}` : null).filter(id => id !== null)

      if (!filterCategories || filterCategories.length === 0) {
        return news
      }

      const hasCategories = data => data.categories && data.categories.length
      const matchFilter = (data, filters) => data.categories.some(cat => filters.includes(cat))
      return news.filter(n => hasCategories(n) && matchFilter(n, filterCategories))
    },

    pageCount() {
      if (this.news.length === 0) { return 0 }
      return Math.ceil(this.news.length / PAGE_ITEM_COUNT)
    },

    pageNews() {
      if (this.news.length === 0) { return null }
      return this.news.slice(0, this.pageCurrent * PAGE_ITEM_COUNT)
    },
  },

  created() {
    this.bestPicFormat = bestPicFormat
  },

  methods: {
    getPopinData() {
      return findNewsBySlug(this.news, this.$route.params.popin)
    },

    getPopinNavItems() {
      let poster, label, url
      const popinNavItems = this.news.map((n) => {
        poster = bestPicFormat(n.image, ['small', 'medium', 'origin'])
        label = n.label
        url = '/actualites/' + n.slug
        return createNavigationPopinItem(
          'MediaThumb',
          { props: { poster, label } },
          url
        )
      })
      return popinNavItems
    },
  }
}
